<template>
  <div>
    <div class="filter-box">
      <ElForm inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model.trim="searchVal" placeholder="请输入搜索人名或账号" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="createMember">创建新成员</ElButton>
        </ElFormItem>
      </ElForm>
    </div>

    <el-table class="common-el-table-styles" :data="tableData" border v-loading="loading" height="calc(100vh - 208px)" style="width: 100%">
      <el-table-column prop="userName" label="账号" width="200"> </el-table-column>
      <el-table-column label="成员显示名" width="120">
        <template slot-scope="{ row }">
          <div class="edit" v-if="!row.isEdit">
            <el-input v-model="row.name" placeholder="请输入" size="small"></el-input>
          </div>
          <span v-else>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="功能角色" :show-overflow-tooltip="true">
        <template slot-scope="{ row }">
          <div class="edit" v-if="!row.isEdit">
            <el-select v-model="row.roleName" placeholder="请选择" filterable multiple size="small" collapse-tags @change="getRoleName">
              <el-option v-for="(item, index) in rolesOptions" :key="index" :label="item.roleName" :value="item.roleId"> </el-option>
            </el-select>
          </div>
          <span v-else>{{ setRoleName(row.roles) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数据权限" :show-overflow-tooltip="true">
        <template slot-scope="{ row }">
          <div class="edit" v-if="!row.isEdit">
            <dataPermission :dataPermissionData="dataPermissionData" @getDataRoles="getDataRoles" :itemData="row"></dataPermission>
          </div>
          <span v-else>{{ setRoleName(row.dataRoles) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="密码" width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.password" v-if="!row.isEdit" size="small"></el-input>
          <span v-else>{{ '********' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="访问记录">
        <template slot-scope="{ row }">
          <div class="access-records">
            <el-button @click="checkVisit(row)" type="text">查看访问记录</el-button>
            <p>&ensp;{{ row.sysLog && row.sysLog.loginTime | datetimeToSec }} {{ row.sysLog && row.sysLog.cityName }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="{ row }">
          <el-button type="text" @click="manager(row)">管家账号</el-button>
          <el-button type="text" @click="edit(row)" v-if="row.isEdit">编辑</el-button>
          <el-button type="text" @click="save(row)" v-if="!row.isEdit">保存</el-button>
          <el-button type="text" @click="dele(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Page
      v-if="tableData.length > 0"
      show-total
      show-sizer
      show-elevator
      :total="total"
      :current.sync="pageIndex"
      :page-size="pageSize"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      class="table-pager"
      size="small"
    />
    <!-- 添加新成员 -->
    <addUser ref="addUsers" :openCreate="openCreate" v-on:openCreateFn="openCreateFn"></addUser>

    <!-- 管家账号弹窗 -->
    <el-dialog title="管家账号" :visible.sync="accountDialog.butlerVisible" width="60%" :before-close="handleClose">
      <butler
        ref="butlers"
        :butlerData="accountDialog.butlerData"
        :accountOptions="accountOptions"
        :butlerVisible="accountDialog.butlerVisible"
      ></butler>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialog.butlerVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitButler">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 访问记录 -->
    <el-dialog title="操作日志" :visible.sync="cooperationLog.visible" width="60%" :before-close="handleClose">
      <cooperationLog :cooperationData="cooperationLog.cooperationData"></cooperationLog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cooperationLog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitLog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import addUser from './addUser'
import butler from './butler'
import dataPermission from './dataPermission'
import {
  queryUsersApi,
  deleteUserApi,
  updatemanager,
  queryAllUsers,
  queryAllRole,
  updateUserApi,
  queryAllChannelManager
} from '@/api/sysmana.model'
import cooperationLog from './cooperationLog'
export default {
  name: 'mamberList',
  components: {
    addUser,
    butler,
    dataPermission,
    cooperationLog
  },
  computed: {},
  data() {
    return {
      searchVal: '',
      tableData: [],
      loading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 30,
      nameOptions: [],
      rolesOptions: [],
      dataPermissionData: [],
      accountDialog: {
        butlerVisible: false,
        butlerData: []
      },
      cooperationLog: {
        visible: false,
        cooperationData: []
      },
      accountOptions: [],
      submitName: '',
      submitRoles: [],
      submitDataRoles: [],
      openCreate: false
    }
  },
  methods: {
    createMember() {
      this.openCreate = true
    },
    openCreateFn() {
      this.openCreate = false
    },
    getData() {
      this.loading = true
      this.tableData = []
      queryUsersApi({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyword: this.searchVal
      }).then((data) => {
        if (data) {
          this.loading = false
          this.total = data.page_info && data.page_info.total_number
          data.list.forEach((item) => {
            this.tableData.push({
              ...item,
              isEdit: true,
              roleName: item.roles && item.roles.length ? item.roles.map((i) => i.roleId) : '',
              password: null
            })
          })
        }
      })
    },
    getAueryAllUsersName() {
      const condition = {
        deptId: '',
        status: 1
      }
      queryAllUsers(condition).then((data) => {
        if (data) {
          this.nameOptions = data
        }
      })
    },
    setRoleName(row) {
      return row ? row.map((i) => i.roleName).join(', ') : ''
    },
    getRole() {
      queryAllRole({
        deptId: '',
        roleType: 2
      }).then((data) => {
        this.dataPermissionData = data
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pageSize = size
      this.getData()
    },
    search() {
      this.pageIndex = 1
      this.getData()
    },
    manager(item) {
      // 管家账号
      this.accountDialog.butlerData = item
      this.accountDialog.butlerVisible = true
    },
    edit(row) {
      // 编辑
      this.getAueryAllUsersName()
      this.tableData.forEach((info) => {
        if (row.userId === info.userId) {
          row.isEdit = false
        } else {
          info.isEdit = true
        }
      })
      // 回显功能角色
      queryAllRole({
        deptId: '',
        roleType: 1
      }).then((data) => {
        this.rolesOptions = data
        this.submitRoles = []
        if (row.roles && row.roles.length) {
          row.roles.forEach((item) => {
            this.submitRoles.push({
              roleId: item.roleId,
              roleName: item.roleName
            })
          })
        } else {
          this.submitRoles = []
        }
      })
    },
    getRoleName(info) {
      this.submitRoles = []
      for (const k of info) {
        this.rolesOptions.forEach((item) => {
          if (k === item.roleId) {
            this.submitRoles.push({
              roleId: k,
              roleName: item.roleName
            })
          }
        })
      }
    },
    getDataRoles(info) {
      this.submitDataRoles = []
      this.submitDataRoles = info
    },
    save(item) {
      // 保存列
      const submitParams = [
        {
          userId: item.userId,
          userName: item.userName,
          name: item.name,
          password: item.password,
          roles: this.submitRoles,
          dataRoles: this.submitDataRoles
        }
      ]
      updateUserApi(submitParams).then((data) => {
        if (data) {
          this.getData()
        }
      })
    },
    checkVisit(item) {
      this.cooperationLog.visible = true
      this.cooperationLog.cooperationData = item
    },
    dele(item) {
      this.$confirm('确认是否删除该成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        deleteUserApi({
          userId: item.userId
        }).then((data) => {
          if (data) {
            this.$message.success('删除成功')
            this.getData()
          }
        })
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    submitButler() {
      // 提交管家账号
      const submitButlerData = this.$refs.butlers.submitParams()
      if (!submitButlerData.allManager && !submitButlerData.managerIds.length) {
        return this.$message.error('请添加账号')
      }
      updatemanager(submitButlerData).then((data) => {
        if (data) {
          this.getData()
          this.accountDialog.butlerVisible = false
        }
      })
    },
    submitLog() {
      // 操作日志
      this.cooperationLog.visible = false
    },
    getAllChannelManager() {
      queryAllChannelManager({
        deptId: ''
      }).then((data) => {
        if (data) {
          this.accountOptions = data
        }
      })
    }
  },
  created() {
    this.getData()
    setTimeout(() => {
      this.getRole()
    }, 500)
    this.getAllChannelManager()
  }
}
</script>
<style lang="scss" scoped>
.filter-box {
  padding-top: 10px;
}

.access-records {
  display: flex;
}
.table-pager {
  padding-top: 8px;
  text-align: right;
}

:deep(.el-select__tags-text) {
  display: inline-block;
  max-width: 130px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:deep(.el-select__tags-text + i) {
  vertical-align: super;
}
</style>
